import { render } from "./date-range-compare.vue?vue&type=template&id=70a6b7a2&ts=true"
import script from "./date-range-compare.vue?vue&type=script&lang=ts"
export * from "./date-range-compare.vue?vue&type=script&lang=ts"

import "./date-range-compare.vue?vue&type=style&index=0&id=70a6b7a2&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__